import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, type SubmitHandler, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import VerificationInput from "react-verification-input";
import type * as yup from "yup";
import { Button } from "@/core/shared/v2/ui/button";
import { Error } from "../error";
import { Header } from "./header";
import { ResendCode } from "./resend-code";
import { useRedirectIfNoVerificationType } from "./use-redirect-if-no-verification-type";
import { useValidationSchema } from "./validatation-schema";

export type CodeValidationFormValues = yup.InferType<ReturnType<typeof useValidationSchema>>;

type CodeValidationFormProps = {
  error?: string;
  onSubmit: (data: CodeValidationFormValues) => void;
  isLoading?: boolean;
  method: "account" | "guest";
};

export const CodeValidationForm = ({ error, onSubmit, isLoading, method }: CodeValidationFormProps) => {
  const { t } = useTranslation();
  useRedirectIfNoVerificationType();
  const validationSchema = useValidationSchema();

  const { control, handleSubmit, errors } = useForm<CodeValidationFormValues>({
    mode: "onTouched",
    resolver: yupResolver(validationSchema),
  });

  const handleOnSubmit: SubmitHandler<CodeValidationFormValues> = (data) => {
    onSubmit(data);
  };

  return (
    <form onSubmit={handleSubmit(handleOnSubmit)}>
      <div className="my-8 flex flex-col items-center">
        <div className="mb-10 flex items-center gap-4">
          <Header />
        </div>
        <Controller
          name="verificationCode"
          control={control}
          defaultValue=""
          render={({ onChange }) => (
            <VerificationInput
              placeholder=""
              validChars="0-9"
              classNames={{
                container: "md:w-[408px] w-full gap-3 md:gap-6",
                character: "rounded-md border-stone-400",
                characterInactive: "bg-background",
              }}
              onChange={onChange}
            />
          )}
        />
        <Error error={errors.verificationCode?.message} className="mt-2" />
        <ResendCode method={method} />
      </div>
      <div className="flex flex-col items-center gap-4">
        <Button variant="primary" size="lg" className="w-full md:w-1/2" type="submit" loading={isLoading}>
          {t("GROUP_ACTIONS_ORDERING.CODE_VALIDATION_FORM.SUBMIT")}
        </Button>
        <Error error={error} className="mt-2" />
      </div>
    </form>
  );
};
